import React from 'react';
export function HeroSection() {
  return <section className="px-4 mb-12" data-id="element-67">
      <h2 className="font-handwriting text-4xl md:text-5xl font-bold text-forest leading-tight mb-4 text-center" data-id="element-68">
        "Felix fraß alles – aber sein Körper profitierte kaum davon"
      </h2>
      <p className="font-serif text-lg text-text/80 text-center mb-8 leading-relaxed px-2" data-id="element-69">
        Wie ich herausfand dass gutes Futter allein nicht reicht – und was
        wirklich hilft.
      </p>
      <div className="relative rounded-2xl overflow-hidden shadow-diary aspect-[4/3] md:aspect-[16/10]" data-id="element-70">
        <img src="https://images.unsplash.com/photo-1543466835-00a7907e9de1?q=80&w=1000&auto=format&fit=crop" alt="Ein süßer, aber dünner Hund schaut erwartungsvoll nach oben" className="w-full h-full object-cover" data-id="element-71" />
        <div className="absolute inset-0 bg-gradient-to-t from-brown/20 to-transparent" data-id="element-72"></div>
      </div>
    </section>;
}